import type { api } from '@stageplottter/core';
import { planActive } from '@stageplottter/core';

type T = (key: string, params?: Record<string, unknown>) => string;

/**
 * Account menu line of the theta-portal plan (U78): "Plan: Pro (until 31.12.2026)", "Plan: Pro
 * (cancelled)" or "No plan – see plans"; null for providers without plans.
 */
export function planMenuLabel(me: api.Me, t: T, locale: string, now: number): string | null {
  if (me.account?.provider !== 'theta' || me.plan === undefined) return null;
  const plan = me.plan;
  if (plan === null) return t('shell.plan.none');
  if (!planActive(plan, now))
    return t('shell.plan.inactive', { name: plan.tierName, status: plan.status });
  if (plan.periodEnd === undefined) return t('shell.plan.active', { name: plan.tierName });
  const until = new Date(plan.periodEnd).toLocaleDateString(locale === 'de' ? 'de-DE' : 'en-GB');
  return t('shell.plan.until', { name: plan.tierName, until });
}

/** Where the plan line leads: Central's product page (plans, upgrade). */
export function plansUrl(me: api.Me): string | null {
  return me.account?.provider === 'theta' && me.account.centralUrl
    ? `${me.account.centralUrl}/products`
    : null;
}
